/**
 * 用 jsPDF 嵌入 TTF 绘制 PDF，带 ToUnicode 文字层，导入时可抽字
 */
import jsPDF from 'jspdf'
import { attachMenuTextPayload } from './menuPdfPayload'

const PAGE_WIDTH = 595.28
const PAGE_HEIGHT = 841.89
const MARGIN = 48
const TITLE_SIZE = 18
const BODY_SIZE = 12
const TITLE_LEADING = 26
const BODY_LEADING = 18
const FONT_NAME = 'MenuCjk'
const FONT_FILE = 'NotoSansSC.ttf'
const FONT_URL = `${process.env.BASE_URL || './'}fonts/${FONT_FILE}`

let fontBase64Promise = null

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  const chunks = []
  const step = 0x8000
  for (let i = 0; i < bytes.length; i += step) {
    chunks.push(String.fromCharCode.apply(null, bytes.subarray(i, i + step)))
  }
  return btoa(chunks.join(''))
}

function loadFontBase64() {
  if (!fontBase64Promise) {
    fontBase64Promise = fetch(FONT_URL).then((res) => {
      if (!res.ok) {
        throw new Error('缺少中文字体，无法导出文字层 PDF')
      }
      return res.arrayBuffer()
    }).then((buf) => arrayBufferToBase64(buf))
  }
  return fontBase64Promise
}

function fullText(content) {
  const title = (content.title || '').trim()
  const body = content.body != null
    ? String(content.body)
    : (content.lines || []).join('\n')
  return [title, body].filter((part) => part !== '').join('\n')
}

/**
 * @param {{ title?: string, lines?: string[], body?: string }} content
 * @returns {Promise<Blob>}
 */
export async function buildTextPdfBlob(content) {
  const fontBase64 = await loadFontBase64()
  const doc = new jsPDF({ unit: 'pt', format: 'a4' })
  doc.addFileToVFS(FONT_FILE, fontBase64)
  doc.addFont(FONT_FILE, FONT_NAME, 'normal')
  doc.setFont(FONT_NAME, 'normal')

  const maxWidth = PAGE_WIDTH - MARGIN * 2
  const text = fullText(content)
  doc.setProperties({
    title: (content.title || '').trim() || '菜单',
    subject: text
  })

  let y = MARGIN
  const drawWrapped = (raw, size, leading) => {
    doc.setFont(FONT_NAME, 'normal')
    doc.setFontSize(size)
    const paragraphs = String(raw || '').replace(/\r\n/g, '\n').split('\n')
    paragraphs.forEach((p) => {
      const wrapped = p === '' ? [''] : doc.splitTextToSize(p, maxWidth)
      wrapped.forEach((line) => {
        if (y + size > PAGE_HEIGHT - MARGIN) {
          doc.addPage()
          y = MARGIN
        }
        if (line) {
          doc.text(line, MARGIN, y + size * 0.85)
        }
        y += leading
      })
    })
  }

  const title = (content.title || '').trim()
  if (title) {
    drawWrapped(title, TITLE_SIZE, TITLE_LEADING)
    y += 8
  }
  const body = content.body != null
    ? String(content.body)
    : (content.lines || []).join('\n')
  drawWrapped(body, BODY_SIZE, BODY_LEADING)

  const pdfBuffer = doc.output('arraybuffer')
  const withPayload = attachMenuTextPayload(pdfBuffer, text)
  return new Blob([withPayload], { type: 'application/pdf' })
}

export async function historyRecordToPdfBlob(item) {
  if (item && item.previewContent) {
    return buildTextPdfBlob({ body: item.previewContent })
  }
  return buildTextPdfBlob({
    title: (item && item.title) || '',
    lines: (item && item.dishNames) || []
  })
}
